import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgSort = function SvgSort(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M7 20h2V8h3L8 4 4 8h3zm13-4h-3V4h-2v12h-3l4 4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSort);

export { ForwardRef as default };
